export var packageVersion = '10.23.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/settings/defaults/version.js
// module id = 3938
// module chunks = 25